module.exports = __webpack_public_path__ + "img/logo.cd02c596.png";